import { Component, ElementRef, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { PreInterviewQuestionsApiService } from './pre-interview-questions-services/pre-interview-questions-api.service';
import { AiGeneratedPreInterviewQuestions } from './pre-interview-questions-typings';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { PreInterviewQuestion } from "../../typings";

@Component({
    selector: 'app-pre-interview-questions',
    templateUrl: './pre-interview-questions.component.html',
    styleUrls: ['./pre-interview-questions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreInterviewQuestionsComponent implements OnInit {
  @ViewChildren('questionComponentCheckbox') questionComponentCheckboxes!: QueryList<ElementRef>;
  pageState: string = this.route.snapshot.params['pageState'];
  orderId: number = Number.parseInt(this.route.snapshot.params['orderId']);
  agentId: number = this.route.snapshot.queryParams['agentId'];

  questionsList: PreInterviewQuestion[];
  staticQuestionsList: PreInterviewQuestion[];
  customQuestionsList: PreInterviewQuestion[];
  aiQuestionsList: PreInterviewQuestion[] = [];
  activeQuestionCount: number;

  constructor(private questionService: PreInterviewQuestionsApiService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.populateQuestionsList();
  }

  populateQuestionsList() {
    if (this.pageState === 'edit') {
      this.aiQuestionsList = [];

      this.generateAiQuestions(this.orderId).subscribe(generatedQuestions => {
        let i: number = 0;

        for (let question of generatedQuestions.preInterviewQuestions) {
          this.aiQuestionsList.push({
            questionId: null,
            customQuestionId: null,
            questionTypeId: 2, // long text
            description: question,
            questionKey: `ai-generated-pre-interview-question-${i}`,
            header: `AI SUGGESTED`,
            headerKey: `pre-interview-questions.category.ai-suggested`,
            questionCategory: 'AI',
            required: false,
            selected: false,
            isActive: false
          });

          i++;
        }

        this.filterAiQuestions();
      });
    }

    let jsonObject: Observable<PreInterviewQuestion[]>;

    if (this.pageState === 'edit') {
      jsonObject = this.getAllQuestions(this.orderId);
    } else {
      jsonObject = this.getSelectedQuestions(this.orderId);
    }

    jsonObject.subscribe(data => {
      this.questionsList = data;
      this.filterStaticQuestions();
      this.filterCustomQuestions();
      this.countActiveQuestions();
    });

  }

  getAllQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.questionService.getAllQuestions(orderId);
  }

  getSelectedQuestions(orderId: number): Observable<PreInterviewQuestion[]> {
    return this.questionService.getSelectedQuestions(orderId);
  }

  generateAiQuestions(orderId: number): Observable<AiGeneratedPreInterviewQuestions> {
    return this.questionService.getAiGeneratedQuestions(this.orderId);
  }

  filterStaticQuestions(): void {
    if (this.pageState === 'edit') {
      this.staticQuestionsList = this.questionsList.filter(question => question.questionCategory != 'CUSTOM');
    }  else {
      this.staticQuestionsList = this.questionsList.filter(question => question.questionCategory != 'CUSTOM' && question.isActive);
    }
  }

  filterCustomQuestions(): void {
    if (this.pageState === 'edit') {
      this.customQuestionsList = this.questionsList.filter(question => question.questionCategory == 'CUSTOM');
    } else {
      this.customQuestionsList = this.questionsList.filter(question => question.questionCategory == 'CUSTOM' && question.isActive);
    }
  }

  filterAiQuestions(): void {
    if (this.pageState === 'edit') {
      this.aiQuestionsList = this.aiQuestionsList.filter(question => question.questionCategory == 'AI');
    } else {
      this.aiQuestionsList = this.aiQuestionsList.filter(question => question.questionCategory == 'AI' && question.isActive);
    }
  }

  countActiveQuestions(): void {
    const selectedQuestions = this.questionsList.map(question => question.selected && question.isActive);
    let count = 0;
    selectedQuestions.forEach(selected => {
      if (selected === true) {
        count += 1;
      }
    });
    this.activeQuestionCount = count;
  }
}
